import React, { useEffect, useRef } from 'react';
import './peopleWorkflow.css';
export function Field({ label, children, hint }) {
  return <label className="people-field"><span>{label}</span>{children}{hint && <small>{hint}</small>}</label>;
}
export function Panel({ title, children, open = false }) {
  return <details className="people-panel" open={open || undefined}><summary>{title}</summary><div className="people-panel-body">{children}</div></details>;
}
export function Message({ children, error = false }) { return children ? <div className={`people-message${error ? ' error' : ''}`} role={error ? 'alert' : 'status'}>{children}</div> : null; }
export function WorkflowDialog({ title, children, onClose, busy }) {
  const ref = useRef(null);
  const closeRef = useRef(onClose); closeRef.current = onClose;
  useEffect(() => {
    const previous = document.activeElement;
    const node = ref.current;
    node?.querySelector('input,select,textarea,button')?.focus();
    const handler = event => {
      if (event.key === 'Escape') { event.preventDefault(); if (!busy) closeRef.current(); }
      if (event.key === 'Tab') {
        const nodes = Array.from(node?.querySelectorAll('input,select,textarea,button,a[href]') || []).filter(item => !item.disabled && item.getClientRects().length);
        if (!nodes.length) return;
        if (event.shiftKey && document.activeElement === nodes[0]) { event.preventDefault(); nodes[nodes.length - 1].focus(); }
        if (!event.shiftKey && document.activeElement === nodes[nodes.length - 1]) { event.preventDefault(); nodes[0].focus(); }
      }
    };
    node?.addEventListener('keydown', handler);
    return () => { node?.removeEventListener('keydown', handler); previous?.focus?.(); };
  }, [busy]);
  return <div className="overlay people-overlay"><section ref={ref} className="people-dialog" role="dialog" aria-modal="true" aria-label={title}><header><h2>{title}</h2><button type="button" className="btn btn-ghost btn-sm" aria-label={`Close ${title}`} disabled={busy} onClick={onClose}>×</button></header>{children}</section></div>;
}
